<template>
  <div>
    <div class="q-mb-md">
      Import posts from your {{ platform.name }} account below.
    </div>
    <import-posts-btn
      :platform="platform"
      :client-id="clientId"
      color="primary"
      class="q-mt-sm"
      rounded
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Account, Platform } from '@/social/types';
import ImportPostsBtn from './ImportPostsBtn.vue';

interface Data {
  account: Account|null
}

export default defineComponent({
  components: {
    ImportPostsBtn,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    platform: {
      type: Object as () => Platform,
      required: true,
    },
  },
});
</script>
